import { getCookie } from "./getCookie";

const metrics = () => {
  /* Установка метрики по клику на кнопку телеграмма */
  (() => {
    const buttonsTelegram = document.querySelectorAll('.TelegramClickSZ');
    
    buttonsTelegram.forEach(button => {
      button.addEventListener('click', () => {
        ym(74433037,'reachGoal','TelegramClickSZ');
      })
    })
  })(); 

  /* Установка на бота _ym_uid из cookie */
  (() => {
    const buttonsBot = document.querySelectorAll('.TelegramBotClick');
    let cookie = getCookie("_ym_uid"),
    session = sessionStorage.getItem("ym_uid");

    if (buttonsBot.length > 0 && cookie || buttonsBot.length > 0 && session) {
      buttonsBot.forEach((button) => {
        if (cookie) {
          button.setAttribute('href', button.getAttribute('href') + "?_ym_uid=" + cookie);    
        } else if (session) {
          button.setAttribute('href', button.getAttribute('href') + "?_ym_uid=" + session);      
        }
      });
    }
  })();
};

export default metrics;
